import axios from 'axios';
import store from '../store';
import router from "../router";

class MetaCredentialsRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    allMetaCredentials() {
        let headers = {'Authorization': store.state.token};
        let response =  axios.get(`${this.basePath}/metatrader-credentials`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }
}

export default new MetaCredentialsRepository();
